import up from 'unpoly';

import { pushToDataLayer } from '../../tracking.ts';

const SELECTOR = '.view-templates-Search-results';

/**
 * Report each set of search results as it is rendered.
 *
 * The search form auto-submits and swaps this container through Unpoly, so
 * refining a query changes the URL without a page load and pushes no further
 * pageviews. An Unpoly compiler runs on the initial render *and* on every
 * swap, which makes "once per result set the visitor actually saw" the natural
 * unit — and it matches what they experienced rather than what they typed.
 *
 * The counts arrive already covering every section, zeros included, because an
 * omitted key would keep the previous search's number (GTM holds data layer
 * values for the rest of the page load).
 *
 * Note the form debounces on a pause in typing rather than on submit, so
 * partial queries are reported too. A run of them ending in a longer query is
 * one visitor refining their search, not several searches.
 */
up.compiler(SELECTOR, ($el) => {
    const searchTerm = $el.dataset.searchTerm;
    const rawCounts = $el.dataset.resultCounts;

    // Absent until something has actually been searched for.
    if (!searchTerm || !rawCounts) {
        return;
    }

    let counts;
    try {
        counts = JSON.parse(rawCounts);
    } catch {
        return;
    }

    const sectionCounts = {};
    let resultCount = 0;

    Object.entries(counts).forEach(([type, count]) => {
        sectionCounts[`result_count_${type}`] = count;
        resultCount += count;
    });

    pushToDataLayer({
        event: 'search',
        search_term: searchTerm,
        result_count: resultCount,
        ...sectionCounts,
    });
});
